import { Outlet } from "react-router-dom";
import { LayoutMainBlock, ContentBlock } from "./styled";
import Sidebar from "./SideBar";
import useUserUpdates from "./useUserUpdates";

const Layout = () => {
  useUserUpdates();

  return (
    <LayoutMainBlock>
      <Sidebar />
      <ContentBlock>
        <Outlet />
      </ContentBlock>
    </LayoutMainBlock>
  );
};

export default Layout;
